// extracted by mini-css-extract-plugin
export default {"Text":"filter-suggestions-module__Text--FTXgw"};